export default __webpack_public_path__ + "static/media/flexline_black_logo.88b00419.png";